import { AxiosResponse } from 'axios';
import find from 'lodash/find';
import last from 'lodash/last';
import { put } from 'redux-saga/effects';

import {
  Activity,
  ActivityController,
  ActivityInstance,
  AppliedActivityListFilters,
  dateType,
  InfoToFetchActivityData,
  Proposal,
} from '@/controllers/Activity';
import { Opportunity } from '@/controllers/Opportunity';
import { ReduxAction, ReduxSagaAction } from '@/types';

import { ActivitiesActionTypes } from './action-types';

export const saveDetailsTargetActivity = (activity: Activity): ReduxAction => ({
  type: ActivitiesActionTypes.SAVE_DETAILS_TARGET_ACTIVITY,
  payload: activity,
});

export const fetchActivities = (appliedFilters: AppliedActivityListFilters): ReduxSagaAction => ({
  type: ActivitiesActionTypes.FETCH_ACTIVITIES.START,
  subtypes: ActivitiesActionTypes.FETCH_ACTIVITIES,
  sagaPayload: { appliedFilters },
  promise: () => ActivityController.fetchAllActivities(appliedFilters),
  onSuccess: function* (result: AxiosResponse) {
    const detailsTarget = last(document.location.pathname.split('/')) || '';

    if (/^[0-2]-[a-zA-Z0-9]{18}$/.test(detailsTarget)) {
      const activity = find(result.data.itemList, { id: detailsTarget.split('-')[1] });

      if (activity) yield put(saveDetailsTargetActivity(activity));
    }
  },
});

export const fetchActivityDetailsData = (
  infoToFetchActivityData: InfoToFetchActivityData,
): ReduxAction => ({
  type: ActivitiesActionTypes.FETCH_ACTIVITY_DETAILS_DATA.START,
  subtypes: ActivitiesActionTypes.FETCH_ACTIVITY_DETAILS_DATA,
  sagaPayload: infoToFetchActivityData,
});

export const fetchTaskStatusesCards = (id: string): ReduxAction => ({
  type: ActivitiesActionTypes.FETCH_TASK_CARD_STATUSES.START,
  payload: id,
});

export const saveCreatedBucketName = (bucketId: string): ReduxAction => ({
  type: ActivitiesActionTypes.SAVE_CREATED_BUCKET_NAME,
  payload: bucketId,
});

export const removeActivities = (): ReduxAction => ({
  type: ActivitiesActionTypes.REMOVE_ACTIVITIES,
});

export const updateActivityPhotoAlbumLink = (
  activityId: string,
  instanceId: ActivityInstance,
  photoAlbumLink: string,
): ReduxAction => ({
  type: ActivitiesActionTypes.UPDATE_ACTIVITY_PHOTO_ALBUM_LINK.START,
  payload: { activityId, instanceId, photoAlbumLink },
});

export const updateAlbumLink = (
  activityId: string,
  activityType: ActivityInstance,
  link: string,
): ReduxSagaAction => ({
  type: ActivitiesActionTypes.UPDATE_ALBUM_LINK.START,
  subtypes: ActivitiesActionTypes.UPDATE_ALBUM_LINK,
  promise: () => ActivityController.updateAlbumLink(activityId, link),
  onSuccess: function* () {
    yield put(fetchActivityDetailsData({ activityId, activityType }));
  },
});

export const selectProposal = (proposal: Proposal | null): ReduxAction => ({
  type: ActivitiesActionTypes.SELECT_PROPOSAL,
  payload: proposal,
});

export const UpdateDetailsOpportunity = (opportunity: Opportunity): ReduxAction => ({
  type: ActivitiesActionTypes.UPDATE_DETAILS_TARGET_OPPORTUNITY,
  payload: opportunity,
});

export const updateTargetActivity = (opportunityId: string): ReduxAction => ({
  type: ActivitiesActionTypes.UPDATE_TARGET_ACTIVITY,
  payload: opportunityId,
});

export const fetchAvailableInstallDates = (activityId: string, dateType: dateType) => ({
  type: ActivitiesActionTypes.FETCH_AVAILABLE_INSTALL_DATES.START,
  subtypes: ActivitiesActionTypes.FETCH_AVAILABLE_INSTALL_DATES,
  promise: () => ActivityController.getAvailableDates(activityId, dateType),
});

export const fetchAvailableDeliveryDates = (activityId: string, dateType: dateType) => ({
  type: ActivitiesActionTypes.FETCH_AVAILABLE_DELIVERY_DATES.START,
  subtypes: ActivitiesActionTypes.FETCH_AVAILABLE_DELIVERY_DATES,
  promise: () => ActivityController.getAvailableDates(activityId, dateType),
});
